var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.273,
    height: 19.913,
    viewBox: "0 0 21.273 19.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "duplicate_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.273,
    height: 19.913,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)",
    clipPath: "url(#duplicate_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9,13.714V5.44a2.067,2.067,0,0,0-.608-1.466,2.1,2.1,0,0,0-1.479-.6H2.462A2.079,2.079,0,0,0,.375,5.44v8.274A2.067,2.067,0,0,0,.983,15.18a2.1,2.1,0,0,0,1.479.6H10.81a2.1,2.1,0,0,0,1.479-.6A2.067,2.067,0,0,0,12.9,13.714Z",
    transform: "translate(1.325 2.445)",
    fill: "none",
    stroke: "#142e38",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.886,10.712H2.625m3.13-3.1v6.206m6.261-1.034H14.1a2.1,2.1,0,0,0,1.479-.6,2.067,2.067,0,0,0,.608-1.466V2.444A2.064,2.064,0,0,0,15.582.978,2.1,2.1,0,0,0,14.1.375H14.1L5.75.392V.386A2.081,2.081,0,0,0,3.668,2.455V4.507",
    transform: "translate(2.205 1.31)",
    fill: "none",
    stroke: "#142e38",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.a146c461240e0b9276ba570b96b3d2f1.svg";
export { ForwardRef as ReactComponent };